import React, { createContext, useState, useEffect, useContext } from 'react';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        console.log("DataContext: Fetching data...");
        try {
            setLoading(true);
            const response = await fetch('/api/get_data.php');
            console.log("DataContext: Response status:", response.status);

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const result = await response.json();
            console.log("DataContext: Data received successfully");
            setData(result);
        } catch (err) {
            console.error('DataContext: Error fetching data:', err);
            setError(err.message);
        } finally {
            setLoading(false);
            console.log("DataContext: Loading finished");
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <DataContext.Provider value={{ data, loading, error, refreshData: fetchData }}>
            {children}
        </DataContext.Provider>
    );
};

export const useData = () => {
    const context = useContext(DataContext);
    if (!context) throw new Error('useData must be used within a DataProvider');
    return context;
};
